import { render, staticRenderFns } from "./DialogueCheck.vue?vue&type=template&id=c20c6d0a&scoped=true&"
import script from "./DialogueCheck.vue?vue&type=script&lang=js&"
export * from "./DialogueCheck.vue?vue&type=script&lang=js&"
import style0 from "./DialogueCheck.vue?vue&type=style&index=0&id=c20c6d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c6d0a",
  null
  
)

export default component.exports